import { useState, useEffect, useRef } from 'react';
import {
  DividendHistoryResponse,
  DividendHistroyData,
  UseDividendHistoryResult,
} from '../../types/dividendhistory.type';
import { getDividendHistroyData } from '../../api/company.api';
import { errorMsg } from '../../constants/common.constant';
import { WidgetError, WidgetMessage } from '../../types/common.type';
import { WidgetMessageType } from '../../lib';

const useDividendData = (
  ric: string = '',
  token: string = '',
  onError?: (error: WidgetError) => void,
  onNoData?: (message: WidgetMessage) => void,
): UseDividendHistoryResult => {
  const [data, setData] = useState<DividendHistroyData>();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const onErrorRef = useRef(onError);
  const onNoDataRef = useRef(onNoData);
  onErrorRef.current = onError;
  onNoDataRef.current = onNoData;

  useEffect(() => {
    let cancelled = false;

    setIsLoading(true);
    setError(null);

    getDividendHistroyData({
      token,
      ric,
    })
      .then((res: DividendHistoryResponse | undefined) => {
        if (!cancelled) {
          if (
            (!res?.data.ratio ||
              Object.keys(res?.data.ratio || {}).length === 0) &&
            !res?.data.history.length &&
            !res?.data.bars.length
          ) {
            throw new Error();
          }
          setData(res?.data);
        }
      })
      .catch((err: Error & { code?: string | number }) => {
        if (!cancelled) {
          const errorMessage =
            err?.message ||
            errorMsg.find((obj) => obj.key === 'dividends')?.label!;

          setError(errorMessage);
          onErrorRef.current?.({
            message: err?.message,
            type: `${err?.name}_${err?.code}`,
          });
        }
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [token, ric]);

  return { data, isLoading, error };
};

export default useDividendData;
